import { render } from "./ShopRegisterPage.vue?vue&type=template&id=29200c9b&scoped=true"
import script from "./ShopRegisterPage.vue?vue&type=script&lang=js"
export * from "./ShopRegisterPage.vue?vue&type=script&lang=js"

import "./ShopRegisterPage.vue?vue&type=style&index=0&id=29200c9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29200c9b"]])

export default __exports__